// components/FeatureSection.jsx
import React from "react";
import "./featuresection.css";

const IndianStreetFeatureSection = () => {
  return (
    <section className="feature-wrapper">
      <div className="image-container">
        <img src="/Images/best coffee shop mandurah.webp" alt="Cafe" className="animated-image" loading="lazy" />
        <div className="circle yellow"></div>
        <div className="circle white"></div>
        <div className="sb-experience">
          <div className="sb-exp-content">
            <p className="sb-h1 sb-mb-10">
              {" "}
              <span> 17 </span>
            </p>
            <p class="sb-h3">
              {" "}
              <span> Years Experiense </span>
            </p>
          </div>
        </div>
      </div>

      <div className="text-container">
        {/* <h2>We are doing more than you expect</h2> */}

        <div className="feature-block">
          {/* <span className="monoton">01</span> */}
          <div>
            <h3>Indian Street Food Takeaway Near You in Mandurah</h3>
            <p>
              Craving Indian Street Food in Mandurah? At Mandurah Cafe, we bring
              you the flavors of Indian street corners straight to Western
              Australia. Try crowd-pleasers like Samosas, Pani Puri, and Pav
              Bhaji-each prepared with traditional methods and fresh
              ingredients.
            </p>
          </div>
        </div>

        <div className="feature-block">
          {/* <span className="monoton">02</span> */}
          <div>
            {/* <h3>Fresh, organic ingredients</h3> */}
            <p>
              Our Indian Street Food menu is perfect for snack lovers and spice
              seekers. We’ve become a go-to street food cafe in Mandurah because
              of our quick service and bold flavors that locals and tourists
              alike can’t get enough of.
            </p>
          </div>
        </div>

        <div className="feature-block">
          {/* <span className="monoton">03</span> */}
          <div>
            {/* <h3>Own fast delivery</h3> */}
            <p>
              Whether you're looking for a quick bite or planning to explore a
              full street-style meal, Mandurah Cafe is the top choice for
              authentic Indian Street Food near Mandurah city center. Swing by
              for a delicious and memorable experience.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndianStreetFeatureSection;
